module.exports = __webpack_public_path__ + "static/pic-b9c5d9b8bdc29efbe838f1ce28494515.jpg";